import { CustomerEndpoint } from '../common/endpoints';
import { CustomerInfo, ServerResponse } from '../common/types';
import { getRequest, putRequest } from './requests';

export async function getAll() {
  const result: ServerResponse<CustomerInfo[]> =
    await getRequest(CustomerEndpoint);
  return result;
}

export async function toggleSuspended(id: number, isSuspended: boolean) {
  const result: ServerResponse<null> = await putRequest(
    `${CustomerEndpoint}/${id}/suspend/${isSuspended}`,
    {}
  );
  return result;
}

export default { getAll, toggleSuspended };
